import Model from './BaseModel'
import i18n from '@/plugins/i18n'
import Bank from './Bank'
import Reseller from './Reseller'

export default class BankAccount extends Model {
    resourceName() {
        return 'bank-accounts'
    }

    fields() {
        return [
            'name',
            'reseller_id',
            'bank_id',
            'agency',
            'account_number',
            'document',
            'pix',
            'active',
            'created_at',
            'deleted_at',
        ]
    }

    relationships() {
        return {
            bank: new Bank(),
            resellers: new Reseller(),
        }
    }

    computed() {
        return {
            bankName(bankAccount) {
                return bankAccount.bank.name
            },

            bankCode(bankAccount) {
                return bankAccount.bank.code
            },

            document(bankAccount) {
                if (bankAccount.document.length >= 14) {
                    return bankAccount.document.replace(
                        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                        '$1.$2.$3/$4-$5',
                    )
                }

                return bankAccount.document.replace(
                    /(\d{3})(\d{3})(\d{3})(\d{2})/,
                    '$1.$2.$3-$4',
                )
            },

            activeText(bankAccount) {
                return bankAccount.active
                    ? i18n.t('bank-account.index.table.active-yes')
                    : i18n.t('bank-account.index.table.active-no')
            },
        }
    }

    get searchable() {
        return ['search']
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('bank-account.index.table.holder'),
                value: 'holder',
                sortable: false,
            },
            {
                text: i18n.t('bank-account.index.table.account-number'),
                value: 'account',
            },
            {
                text: i18n.t('bank-account.index.table.active'),
                value: 'activeText',
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }
}
